import { render, staticRenderFns } from "./orderLayout.vue?vue&type=template&id=94774be2&scoped=true&"
import script from "./orderLayout.vue?vue&type=script&lang=js&"
export * from "./orderLayout.vue?vue&type=script&lang=js&"
import style0 from "./orderLayout.vue?vue&type=style&index=0&id=94774be2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94774be2",
  null
  
)

export default component.exports